import { CategoryDetailEnum } from '../../../generated/globalTypes';

export let categoryTypeUnverifPP = ['Data', 'Foto', 'Dokumen'] as const;

const standardNextAction =
  'Foto / dokumen masih belum sesuai ketentuan. Silakan unggah ulang dengan foto / dokumen yang jelas dan seluruh informasi terbaca.';
const notOriginalNextAction =
  'Foto / dokumen bukan dokumen asli. Silahkan unggah ulang dan pastikan asli bukan screenshot atau hasil fotocopy';
const notValidNextAction =
  'Foto / dokumen sudah tidak valid. Silahkan unggah ulang dengan foto / dokumen terbaru yang masih valid';
const dataNextAction =
  'Silahkan update kembali dan pastikan data peserta sesuai dengan yang tercantum dalam daftar anggota keluarga di KK';

const fotoProblems = [
  {
    problem: 'Foto tidak jelas (buram / kurang cahaya / terpotong)',
    nextAction: standardNextAction,
  },
  {
    problem:
      'Bukan foto dokumen asli (tidak diambil langsung / fotocopy / screenshot)',
    nextAction: notOriginalNextAction,
  },
  {
    problem: 'Informasi pada foto dokumen ada yang ditutupi / dicoret',
    nextAction: standardNextAction,
  },
];

const docProblems = [
  {
    problem: 'Dokumen tidak jelas (buram / terpotong)',
    nextAction: standardNextAction,
  },
  {
    problem:
      'Dokumen yang diupload tidak lagi valid (versi terbaru / masih sesuai tanggal berlaku)',
    nextAction: notValidNextAction,
  },
  {
    problem: 'Informasi pada dokumen ada yang ditutupi / dicoret',
    nextAction: standardNextAction,
  },
];

export let problem = {
  foto: {
    problems: fotoProblems,
  },
  fotoNPWP: {
    problems: [
      ...fotoProblems,
      { problem: 'Salah Upload NPWP', nextAction: notOriginalNextAction },
    ],
  },
  fotoKTP: {
    problems: [
      ...fotoProblems,
      { problem: 'Salah Upload KTP', nextAction: notOriginalNextAction },
    ],
  },
  doc: {
    problems: docProblems,
  },
  visa: {
    problems: [
      {
        problem:
          'Dokumen atau berkas yang diunggah tidak sesuai dengan persyaratan.',
        nextAction: standardNextAction,
      },
      {
        problem:
          'Tampilan dokumen tidak jelas, buram, atau tidak dapat terbaca.',
        nextAction: standardNextAction,
      },
      {
        problem:
          'Informasi pada dokumen terpotong, tertutupi, atau terdapat coretan.',
        nextAction: standardNextAction,
      },
    ],
  },
  data: {
    problems: [
      {
        problem:
          'KK tidak jelas (tidak terbaca), informasi ada yang ditutupi / dicoret, ada yang terpotong',
        nextAction: dataNextAction,
      },
      {
        problem: 'Salah Upload KK',
        nextAction: dataNextAction,
      },
      {
        problem: 'Data peserta 1 tidak tercantum pada dokumen KK',
        nextAction: dataNextAction,
      },
      {
        problem: 'Data peserta 2 tidak tercantum pada dokumen KK',
        nextAction: dataNextAction,
      },
    ],
  },
};

export let categoryDetailUnverifPP = [
  {
    categoryType: categoryTypeUnverifPP[0],
    detailCategoryId: CategoryDetailEnum.DATA_PARTICIPANT_1,
    detailName: 'Peserta 1',
    ...problem.data,
  },
  {
    categoryType: categoryTypeUnverifPP[0],
    detailCategoryId: CategoryDetailEnum.DATA_PARTICIPANT_2,
    detailName: 'Peserta 2',
    ...problem.data,
  },
  {
    categoryType: categoryTypeUnverifPP[1],
    detailCategoryId: CategoryDetailEnum.PASS_PHOTO_PARTICIPANT_1,
    detailName: 'Pas Foto Peserta 1',
    ...problem.foto,
  },
  {
    categoryType: categoryTypeUnverifPP[1],
    detailCategoryId: CategoryDetailEnum.PASS_PHOTO_PARTICIPANT_2,
    detailName: 'Pas Foto Peserta 2',
    ...problem.foto,
  },
  {
    categoryType: categoryTypeUnverifPP[1],
    detailCategoryId: CategoryDetailEnum.NPWP,
    detailName: 'NPWP',
    ...problem.fotoNPWP,
  },
  {
    categoryType: categoryTypeUnverifPP[1],
    detailCategoryId: CategoryDetailEnum.KTP_PARTICIPANT_1,
    detailName: 'KTP Peserta 1',
    ...problem.fotoKTP,
  },
  {
    categoryType: categoryTypeUnverifPP[1],
    detailCategoryId: CategoryDetailEnum.KTP_PARTICIPANT_2,
    detailName: 'KTP Peserta 2',
    ...problem.fotoKTP,
  },
  {
    categoryType: categoryTypeUnverifPP[2],
    detailCategoryId: CategoryDetailEnum.KK,
    detailName: 'KK',
    ...problem.doc,
  },
  {
    categoryType: categoryTypeUnverifPP[2],
    detailCategoryId: CategoryDetailEnum.PASSPORT_PARTICIPANT_1,
    detailName: 'Passport Peserta 1',
    ...problem.doc,
  },
  {
    categoryType: categoryTypeUnverifPP[2],
    detailCategoryId: CategoryDetailEnum.PASSPORT_PARTICIPANT_2,
    detailName: 'Passport Peserta 2',
    ...problem.doc,
  },
  {
    categoryType: categoryTypeUnverifPP[2],
    detailCategoryId: CategoryDetailEnum.VISA_PARTICIPANT_1,
    detailName: 'Visa Peserta 1',
    ...problem.visa,
  },
  {
    categoryType: categoryTypeUnverifPP[2],
    detailCategoryId: CategoryDetailEnum.VISA_PARTICIPANT_2,
    detailName: 'Visa Peserta 2',
    ...problem.visa,
  },
];
